<template>
    <div >

        <v-form ref="form" v-model="valid_form" lazy-validation>
            <v-dialog
                v-model="openDialog"
                :fullscreen="fullscreen"
                hide-overlay
                transition="dialog-bottom-transition"
                width="auto"
                @click:outside="close"
            >

              
              <v-card class="mx-auto">
                <v-toolbar
                  dark
                  color="primary"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    dark
                    @click="close"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title @click="close">{{ $t('solar.close') }}</v-toolbar-title>
                  
                  
                </v-toolbar>
                <v-card-title style="word-break: break-word">
                  <span class="headline">{{ modalTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>

                    <v-col class="d-flex justify-space-around mb-6 align-end" cols="6">
                        <v-autocomplete 
                            v-model="selected_persons" 
                            :items="filteredEmployees" 
                            item-text="username" 
                            item-value="id"
                            :label="$t('active_source.persons')" 
                            persistent-hint 
                            small-chips 
                            multiple 
                            dense 
                            clearable
                            deletable-chips 
                            return-object
                            >
                           
                        </v-autocomplete>
                    </v-col>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                      
                        <v-btn color="blue"  dark   @click="close">{{ $t('globals.cancel') }}</v-btn> 
                        <v-btn color="success"  @click.native="saveSelectedPersons" >{{ $t('globals.save') }}</v-btn>
                    
                    </v-card-actions>

                    <!-- Tabla para preguntas 1-3 (names_only) con campo de texto para explicar por qué -->
                    <span v-if="responseType=='names_only' && selected_persons.length > 0">

                       <v-simple-table
                          fixed-header
                        >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">
                                  {{ $t('solar.person') }}
                                </th>
                                <th class="text-left">
                                  {{ $t('solar.why_reason') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(person) in selected_persons"
                                :key="person.id"
                              >
                                <td width="30%">{{ person.username }}</td>
                                <td>
                                  <v-textarea
                                    outlined
                                    class="mt-4"
                                    :name="`reason-${person.id}`"
                                    :placeholder="modalTitle"
                                    v-model="reasons[`${person.id}`]"
                                    rows="2"
                                  ></v-textarea>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>

                    </span>

                    <!-- Tabla para pregunta 4 (names_with_text o names_with_options) - siempre con campo de texto abierto -->
                    <span v-if="(responseType=='names_with_text' || responseType=='names_with_options') && selected_persons.length > 0">

                       <v-simple-table
                          fixed-header

                        >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">
                                  {{ $t('solar.person') }}
                                </th>
                                <th class="text-left">
                                  {{ $t('solar.reasons') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(person) in selected_persons"
                                :key="person.id"
                              >
                                <td width="30%">{{ person.username }}</td>
                                <td>
                                  <!-- Campo de texto abierto para pregunta 4 y otras preguntas con texto -->
                                  <v-textarea
                                    outlined
                                    class="mt-4"
                                    :name="`reason-${person.id}`"
                                    :label="$t('solar.describe_reasons')"
                                    v-model="reasons[`${person.id}`]"
                                    rows="3"
                                  ></v-textarea>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>

                    </span>
                   
                    

                  </v-container>
                </v-card-text>
                
              </v-card>
            </v-dialog>
        </v-form>

  </div>

</template>

<script>
import { useMainStore } from '@/store/main';
import { mapStores} from 'pinia';
  
    export default {

      name: "SelectPersonsDialog",

      props:[
            'modalTitle',
            'showDialog',
            'questionID',
            'responseType',
            'defaultOptions',
            'maxSelections',
            'solarQuestion',
            'fullscreen'
            
        ],

      data: () => ({

            openDialog:false,
            valid_form:false ,
            selected_persons:[],
            selected_area:'',
            reasons:{},
            response_options:[],
            showTextArea:[]

        }),


      mounted(){

        // console.log('entra amounted!')

      },

      watch: {

        showDialog: {

            handler: function (val) {

              // console.log(val);

                this.openDialog=val

            },
            // deep: true,
            // immediate:true

        },


        defaultOptions: {

            handler: function (val) {


              if(val !== undefined){

                if(this.responseType==='names_with_text'){

                    for (let key in val) {

                      this.selected_persons.push(this.filteredEmployees.find(person => person.id==key));
                      this.reasons[key]=val[key];

                    }

                }
                else if(this.responseType==='names_with_options'){
                  // Pregunta 4: puede ser formato antiguo (objeto con options y text) o nuevo (solo texto)
                  for (let key in val) {
                    this.selected_persons.push(this.filteredEmployees.find(person => person.id==key));
                    // Verificar si es formato antiguo o nuevo
                    if(val[key] && typeof val[key] === 'object' && val[key].text !== undefined){
                      // Formato antiguo: {options: [...], text: "..."}
                      this.reasons[key]=val[key].text || "";
                    } else {
                      // Formato nuevo: solo texto
                      this.reasons[key]=val[key];
                    }
                  }


                }
                else if(this.responseType==='names_only'){
                  // Preguntas 1-3: puede ser formato antiguo (array) o nuevo (objeto con ID -> razón)
                  if(Array.isArray(val)){
                    // Formato antiguo: array de IDs
                    val.forEach(id =>{
                      this.selected_persons.push(this.filteredEmployees.find(person => person.id==id));
                    });
                  } else {
                    // Formato nuevo: objeto con ID -> razón
                    for (let key in val) {
                      this.selected_persons.push(this.filteredEmployees.find(person => person.id==key));
                      this.reasons[key]=val[key];
                    }
                  }

                }

              }

              // this.selected_persons = val;

            },
              // deep: true,
              // immediate:true

        },


        selected_persons: {

          handler: function (val) {

            if (this.maxSelections!=undefined && val.length > this.maxSelections){
              alert('Máximo '+ this.maxSelections +' nombres seleccionados permitidos!!');
              this.selected_persons.pop();
              return;
            }

            // Inicializar razones para cada persona seleccionada (necesario para reactividad)
            if(val && val.length > 0){
              val.forEach(person => {
                if(!(person.id in this.reasons)){
                  this.$set(this.reasons, person.id, '');
                }
              });
            }

          },
          //  deep: true,
          //  immediate:true

        },

        },

      computed: {

            // ...mapState(useMainStore, ["selected_cycle"]),
            ...mapStores(useMainStore),


            filteredEmployees() {

              // console.log(this.mainStore.employees)



                //if question_id is 1 , then filters employees by grade

                if(this.solarQuestion && this.solarQuestion.id_question==1){
                  return this.mainStore.employees.filter(item => item.organization_area.Organization_area_es.slice(0, -1) === this.mainStore.logged_user.area_name.slice(0, -1));

                }
                else if (this.solarQuestion && this.solarQuestion.id_question==2){
                  return this.mainStore.employees.filter(item => item.id_organization_area === this.mainStore.logged_user.area_id);

                }
                else if (this.solarQuestion && this.solarQuestion.id_question==3){
                  return this.mainStore.employees.filter(item => item.organization_area.Organization_area_es.slice(0, -1) === this.mainStore.logged_user.area_name.slice(0, -1));

                }
                else if (this.solarQuestion && this.solarQuestion.id_question==4){
                  return this.mainStore.employees.filter(item => item.organization_area.Organization_area_es.slice(0, -1) === this.mainStore.logged_user.area_name.slice(0, -1));

                }
                else{

                  return this.mainStore.employees;
                }


            },

            options(){

              return JSON.parse(this.solarQuestion.question_possible_answers[`Question_possible_answers_${this.$i18n.locale}`]);

            },
           
            
        },


      methods: {


        optionIsSelected(evento, personID,option_name){

         let opt_obj= this.optionExists(option_name);

         if(opt_obj && evento.includes(opt_obj.valor)){
            this.showTextArea[personID]=true;

           }
    
          else  this.showTextArea[personID]=false;    

         
        },


        setTextAreaContent(evento, personID,option_name, content){

          // let opt_obj= this.optionExists(option_name);

          // if(opt_obj && evento.includes(opt_obj.valor)){
            // this.showTextArea[personID]=true;
            this.reasons[personID]=content;

            // }

          // else  this.showTextArea[personID]=false;    


          },


          optionExists(option_name){

            return this.options.find(option => option.texto===option_name);

          },

          
          
          close() {

              this.openDialog = false;
              this.selected_persons=[];
              this.reasons={};
              this.$emit('close');

            },

          clear() {
            this.$refs.form.reset();
            this.selected_persons=[];
           },

          saveSelectedPersons(){

            let  data ={};

            // VALIDACIÓN OBLIGATORIA PARA PREGUNTA 4: Verificar que todas las razones estén escritas
            const esPregunta4 = this.solarQuestion && this.solarQuestion.id_question == 4;

            if(esPregunta4 && this.selected_persons.length > 0){
              let missingReasons = [];
              this.selected_persons.forEach(person=>{
                const reason = this.reasons[person.id];
                if(!reason || (typeof reason === 'string' && reason.trim().length === 0)){
                  missingReasons.push(person.username);
                }
              });

              if(missingReasons.length > 0){
                alert(this.$t('solar.all_reasons_required') + '\n\n' + this.$t('solar.missing_reasons_for') + ' ' + missingReasons.join(', '));
                return;
              }
            }

            // Si no hay personas seleccionadas, enviar null para eliminar todas las respuestas
            if(this.selected_persons.length === 0){
              data ={
                'selected_persons': null,
                'questionID':this.questionID
              }
            }
            else if(this.responseType=='names_with_text'){

              this.selected_persons.forEach(person=>{
                if(!(person.id in this.reasons)){
                  this.reasons[person.id]=" ";
                }

              });

              data ={
                'selected_persons':this.reasons,
                'questionID':this.questionID
              }
            }
            else if(this.responseType=='names_with_options'){
              // Limpiar razones solo de personas seleccionadas
              let cleanReasons = {};
              this.selected_persons.forEach(person=>{
                const reason = this.reasons[person.id] || '';
                cleanReasons[person.id] = typeof reason === 'string' ? reason.trim() : reason;
              });

              data ={
                'selected_persons': cleanReasons,
                'questionID':this.questionID
              }
            }
            else if(this.responseType=='names_only') {
              // Para preguntas 1-3: guardamos los IDs junto con las razones de por qué les gusta
              let selected_persons_with_reasons = {};

              this.selected_persons.forEach(person=>{
                const reason = this.reasons[person.id] || "";
                selected_persons_with_reasons[person.id] = reason;
              });

              data ={
                'selected_persons':selected_persons_with_reasons,
                'questionID':this.questionID
              }

            }

            this.$emit('personsSelected', data);
            this.close();


           }

        }
    }
</script>

